import click from '@assets/audio/clic_button.mp3';
import good from '@assets/audio/feedback.mp3';
import select from '@assets/audio/select_quizz.mp3';
import valid from '@assets/audio/validate_button.mp3';
import woosh from '@assets/audio/woosh2.mp3';
import wrong from '@assets/audio/wrong.mp3';
//import { Howl } from 'howler';
import { useEffect, useState } from 'react';

type TSound =
  | 'feedbackGood'
  | 'feedbackWrong'
  | 'select'
  | 'woosh'
  | 'click'
  | 'valid';
export default function useSoundAudio() {
  const [myAudio] = useState(new Audio(''));
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    myAudio.onended = () => setPlaying(false);
    myAudio.addEventListener('ended', listenerEnded);

    return () => {
      myAudio.removeEventListener('ended', listenerEnded);
    };
  }, []);

  function listenerEnded() {
    setPlaying(false);
  }

  function playSound(type: TSound) {
    switch (type) {
      case 'feedbackGood':
        myAudio.src = good;
        break;
      case 'feedbackWrong':
        myAudio.src = wrong;
        break;
      case 'woosh':
        myAudio.src = woosh;
        break;
      case 'select':
        myAudio.src = select;
        break;
      case 'click':
        myAudio.src = click;
        break;
      case 'valid':
        myAudio.src = valid;
        break;
      default:
        console.log('erreur son');
    }
    myAudio.volume = 0.5;
    setPlaying(true);
    void myAudio.play();
  }
  return { playSound, playing };
}
